import { IS_CLIENT_SERVER } from "./appConfig";

export default {
  api: {
    // baseURL: 'http://socket-io.devstree.in/smartapp/api/',
    baseURL: IS_CLIENT_SERVER
      ? "https://toshavhaham.co.il/smartapp/api/"
      : "https://socket-io.devstree.in/api/",
    //baseURL: IS_CLIENT_SERVER ? 'https://toshavhaham.co.il/smartapp/api/' : 'http://socket-io.devstree.in/smartapp/api/',
    baseAdminUrl: "https://toshavhaham.co.il/smartapp/",
    timeout: 25000
  }
};

//http://socket-io.devstree.in/api/apple/callback

//https://toshavhaham.co.il/smartapp/api/
//http://78.47.88.161/smartapp/api/
